'use client'
import { useState, useRef, useEffect } from "react"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

const tours = [
  {
    title: "Tour por Isla Mujeres",
    price: "$55 USD",
    description:
      "Navega en catamarán desde Cancún hacia Isla Mujeres. 7 horas de aventura con barra libre, snorkel en un arrecife con estatuas submarinas y comida buffet en un club de playa privado.",
    img: "/Tours/isla-mujeres.jpg",
  },
  {
    title: "Tour por Isla Saona",
    price: "$65 USD",
    description:
      "Visita la icónica Isla Saona con catamarán y lancha rápida. Aguas turquesa, piscinas naturales con estrellas de mar, playa paradisíaca y buffet típico en un entorno ecológico único.",
    img: "/Tours/isla-saona.jpg",
  },
  {
    title: "Guatapé y El Peñol",
    price: "$45 USD",
    description:
      "Recorrido por El Retiro, réplicas históricas de El Peñol, almuerzo con vistas al embalse, caminata por Guatapé y sus zócalos. Incluye guía, transporte y paradas panorámicas.",
    img: "/Tours/guatape_penol.jpg",
  },
  {
    title: "4 Islas + Plancton en Cartagena",
    price: "$70 USD",
    description:
      "Tour por las Islas del Rosario con snorkel, Cholon, Agua Azul y Playa Tranquila. Almuerzo típico incluido y actividad nocturna de plancton bioluminiscente.",
    img: "/Tours/cartagena_4_islas.jpg",
  },
  {
    title: "Lo Mejor de Panamá",
    price: "$50 USD",
    description:
      "Recorrido por el Casco Antiguo, el Centro de Visitantes de Miraflores para ver el Canal en acción y visita a Albrook Mall. Ideal para descubrir Panamá en un día.",
    img: "/Tours/panama_canal.jpg",
  },
  {
    title: "Hop On Hop Off Madrid",
    price: "$35 USD",
    description:
      "Explora Madrid a tu ritmo con un autobús turístico de dos pisos. Sube y baja en cualquiera de sus rutas, audioguía en 14 idiomas y conoce los puntos icónicos de la ciudad.",
    img: "/Tours/madrid_bus.jpg",
  },
  {
    title: "Torre Eiffel + Crucero por el Sena",
    price: "$165 USD",
    description:
      "Recorrido panorámico por París, acceso sin filas a la Torre Eiffel (2° piso) y crucero por el río Sena. Historia, cultura y vistas inolvidables de la Ciudad Luz.",
    img: "/Tours/eiffel_sena.jpg",
  },
  {
    title: "Disney World",
    price: "$250 USD",
    description:
      "Descubre los 4 parques temáticos: Magic Kingdom, Epcot, Hollywood Studios y Animal Kingdom. Atracciones, shows, personajes y toda la magia de Disney.",
    img: "/Tours/disneyworld.jpg",
  },
];

const INTERVAL = 5000;

const Tours = () => {
  const [current, setCurrent] = useState(0);
  const [progress, setProgress] = useState(0);
  const timeoutRef = useRef(null);
  const progressRef = useRef(null);

  const resetTimers = () => {
    clearTimeout(timeoutRef.current);
    clearInterval(progressRef.current);
    setProgress(0);
    let elapsed = 0;
    progressRef.current = setInterval(() => {
      elapsed += 50;
      setProgress(Math.min((elapsed / INTERVAL) * 100, 100));
    }, 50);
    timeoutRef.current = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % tours.length);
    }, INTERVAL);
  };

  useEffect(() => {
    resetTimers();
    return () => {
      clearTimeout(timeoutRef.current);
      clearInterval(progressRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  const goTo = (idx) => setCurrent(idx);
  const prevSlide = () => setCurrent((current - 1 + tours.length) % tours.length);
  const nextSlide = () => setCurrent((current + 1) % tours.length);

  return (
    <div id="tours" className="mx-auto mt-24 max-w-7xl px-6 sm:mt-32 lg:px-8 scroll-mt-28">

      <div className="mx-auto max-w-2xl lg:mx-0 mb-12">
        <p className="text-sm font-semibold uppercase tracking-widest mb-3" style={{ color: '#F5A020' }}>
          Nuestros Tours
        </p>
        <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
          Los mejores destinos, los mejores precios
        </h2>
        <p className="mt-4 text-base text-gray-500">
          Viaja más, paga menos. Experiencias únicas en cada rincón del mundo.
        </p>
      </div>

      <div className="w-full relative overflow-hidden rounded-3xl shadow-xl">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {tours.map((tour, index) => (
            <div key={index} className="min-w-full flex flex-col lg:flex-row bg-white">
              <div className="relative w-full lg:w-1/2 h-[280px] lg:h-[480px] overflow-hidden">
                <img
                  src={tour.img}
                  alt={tour.title}
                  className="w-full h-full object-cover"
                />
                <div
                  className="absolute top-5 left-5 px-4 py-1.5 rounded-full text-white font-bold text-sm"
                  style={{ background: '#F5A020' }}
                >
                  Desde {tour.price}
                </div>
              </div>

              <div className="flex flex-col justify-center p-8 lg:p-12 lg:w-1/2 bg-gray-50">
                <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#2E38A4' }}>
                  Experiencia incluida
                </p>
                <h3 className="text-2xl lg:text-3xl font-extrabold text-gray-900 leading-tight">
                  {tour.title}
                </h3>
                <p className="mt-4 text-gray-500 leading-relaxed text-sm lg:text-base">{tour.description}</p>

                <div className="flex flex-wrap gap-2 mt-6">
                  {['Guía incluido', 'Reserva fácil', 'Precio garantizado'].map(tag => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-full text-xs font-semibold"
                      style={{ background: '#EEF0FF', color: '#2E38A4' }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <a
                  href={`https://wa.me/50239990332?text=${encodeURIComponent(
                    `Hola, quiero más información sobre: ${tour.title}`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-8 w-fit inline-flex items-center px-7 py-3.5 rounded-xl font-bold text-white text-sm shadow transition hover:opacity-90"
                  style={{ background: '#25D366' }}
                >
                  Reservar por WhatsApp
                </a>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/90 text-gray-700 rounded-full shadow hover:bg-white transition"
        >
          <ChevronLeftIcon className="w-5 h-5" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/90 text-gray-700 rounded-full shadow hover:bg-white transition"
        >
          <ChevronRightIcon className="w-5 h-5" />
        </button>
      </div>

      {/* Barra de progreso */}
      <div className="mt-3 h-0.5 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full"
          style={{ width: `${progress}%`, background: '#F5A020', transition: 'width 50ms linear' }}
        />
      </div>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-4">
        {tours.map((_, idx) => (
          <button
            key={idx}
            onClick={() => goTo(idx)}
            className="h-1.5 rounded-full transition-all duration-300"
            style={{
              width: idx === current ? '24px' : '6px',
              background: idx === current ? '#2E38A4' : '#D1D5DB',
            }}
          />
        ))}
      </div>

      <p className="text-center text-xs text-gray-400 mt-2">
        {current + 1} de {tours.length}
      </p>
    </div>
  );
};

export default Tours;
